import type { FlattenedSectionProps } from "../../../../components/Questionnaire/Section";
import { setAddressQuestionVisibility } from "../../../questionnaire/utils/setAddressMode";
import type { QuestionnaireState, AddressMode } from "../../types";
import { getVisibilityMap } from "../../../questionnaire/utils/getVisibilityMap";

export const handleSetAddressModeAction = (
  state: QuestionnaireState,
  payload: { name: string; mode: AddressMode },
): QuestionnaireState => {
  const { name, mode } = payload;
  const { addressModes } = state;
  const updatedAddressModes = {
    ...addressModes,
    [name]: mode,
  };
  const { sections, answers } = setAddressQuestionVisibility(
    name,
    state.sections as unknown as FlattenedSectionProps[],
    updatedAddressModes,
    state.answers,
  );

  return {
    ...state,
    sections,
    visibility: getVisibilityMap({
      sections,
      addressModes: updatedAddressModes,
      groups: {},
      visibility: {},
    }),
    addressModes: updatedAddressModes,
    answers,
  };
};
